import { createAction, props } from '@ngrx/store';
import type { FormAddress } from '@innogy/common-ui/forms';
import { createNamedOrderFormActions } from '@innogy/feh/shared';

import type { HeatPumpCampaignState } from './heatpumps-order-form.reducer';

const feature = 'Heatpumps';
const PREFIX = `[${feature} Order Form]`;

export const { resetHeatpumpsOrderFormAction } =
  createNamedOrderFormActions<typeof feature>(feature);

export const prefillHeatpumpsOrderFormAddressStateAction = createAction(
  `${PREFIX} Prefill address form data`,
  props<{ payload: Partial<FormAddress> }>()
);

export const initHeatpumpsOrderFormCheckboxMapping = createAction(
  `${PREFIX} Initialize checkbox mapping`,
  props<{ mapping: { [key: string]: string } }>()
);

export const initHeatpumpsOrderFormCampaignState = createAction(
  `${PREFIX} Initialize campaign state`,
  props<{ campaign: HeatPumpCampaignState }>()
);
